export default __webpack_public_path__ + "static/media/image4.5a4b7560.jpg";